<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-11-03 17:10:00
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-02 14:57:28
-->
<template>
	<div :class="['view', bg ? 'bg' : '']">
		<el-table :data="sku_list" class="table" :span-method="spanMethod" header-row-class-name="table-header-sku" row-class-name="table-row">
			<el-table-column label="规格" prop="name" align="center">
				<template v-slot="{ row }">
					<span class="fz-12">{{ row.specification | formatEmpty }}</span>
				</template>
			</el-table-column>
			<el-table-column label="现售价" prop="price" align="center" width="100">
				<template v-slot="{ row }">
					<span class="fz-12">{{ row.price | formatEmpty | formatPrice }}</span>
				</template>
			</el-table-column>
			<el-table-column label="申样数量" prop="nums" align="center" width="100">
				<template v-slot="{ row }">
					<span class="fz-12">{{ row.nums | formatEmpty }}</span>
				</template>
			</el-table-column>
			<el-table-column label="规格备注" prop="nums" align="center" width="140">
				<template v-slot="{ row }">
					<span class="fz-12">{{ row.specification_remark | formatEmpty }}</span>
				</template>
			</el-table-column>
		</el-table>
		<div class="footer flex-row font-h6-regular yx-color-text-regular">
			<p class="yx-color-text-primary yx-color-text-regular flex-1">合计</p>
			<p style="width: 100px;"></p>
			<p style="width: 100px;">{{ total }}</p>
			<p style="width: 140px;"></p>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		sku_list: {
			type: Array,
			default: () => [],
		},
		bg: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		total({ sku_list }) {
			let nums = sku_list.reduce((prev, item) => {
				return prev + Number(item.nums);
			}, 0);
			return nums;
		},
	},
	methods: {
		// 合并单元格方法
		spanMethod({ row: { rowspan, colspan }, column, rowIndex, columnIndex }) {
			if ([3].includes(columnIndex)) {
				if (rowIndex === 0) {
					return {
						rowspan: this.sku_list.length,
						colspan: 1,
					};
				} else {
					return {
						rowspan: 0,
						colspan: 1,
					};
				}
			}
		},
	},
};
</script>
<style lang="less" scoped>
.view {
	background-color: #fff;
	border-radius: 8px;
	::v-deep .el-table .el-table__cell {
		vertical-align: top;
	}
	/deep/.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
		background-color: #ffffff;
	}
	/deep/ .el-table__body-wrapper {
		max-height: 360px;
		overflow-y: auto;
		&::-webkit-scrollbar {
			width: 6px;
		}
		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @border-color-lighter;
		}
	}
	::v-deep .table-header-sku th {
		border-bottom: 1px solid #f0f1f5 !important;
	}
	.footer {
		padding: 14px 0px;
		background-color: #f7f8fa;
		border-radius: 2px;
		p {
			padding: 0px 16px;
			box-sizing: border-box;
		}
	}
	::v-deep .el-table__row:first-child td:last-child {
		border-left: 1px solid @border-color-base;
	}
}

.table::before {
	height: 0 !important;
}

.is-border {
	& + & {
		border-top: 1px solid #eaebf0;
	}
}
</style>
